import { initRegion } from '@/consts'
import { regionAtom } from '@/store/root.ts'
import { CloseOutlined } from '@ant-design/icons'
import { getSysComRegionGetRegionByIP } from '@s/sys.ts'
import { Button } from 'antd'
import { AnimatePresence } from 'framer-motion'

const RegionInspect = () => {
  const [region, setRegion] = useAtom(regionAtom)

  const { data } = useQuery({
    queryKey: ['ip region'],
    queryFn: getSysComRegionGetRegionByIP,
    select: res => {
      if (isValidRes(res)) {
        return res.data.map(item => ({
          label: item.name!,
          value: item.id!,
        }))
      }
    },
  })

  const [show, setShow] = useState(JSON.stringify(region) === JSON.stringify(initRegion))

  const switchRegion = () => {
    if (data) {
      setRegion(data)
      setShow(false)
      window.location.reload()
    }
  }

  return (
    <AnimatePresence initial={false}>
      {data && show ? (
        <motion.div
          animate={{ height: 'auto', opacity: 1 }}
          className="relative"
          exit={{ height: 0, opacity: 0 }}
          initial={{ height: 0, opacity: 0 }}
        >
          <div className="container py-2 text-right">
            <span>
              您当前位于：<span className="text-main">{data?.map(item => item.label).join('，')}</span>
              ，是否立即切换地区？
            </span>
            <Button size="small" type="primary" onClick={switchRegion}>
              切换
            </Button>
          </div>
          <CloseOutlined className="right-4 abs-center-y" onClick={() => setShow(false)}>
            关闭
          </CloseOutlined>
        </motion.div>
      ) : null}
    </AnimatePresence>
  )
}

export default RegionInspect
